<!-- Corporate Details Header Section -->
<div class="corporate-details-container">
  <div class="corporate-header">
    <div class="header-content">
      <div class="corporate-info">
        <h1 class="corporate-name">
          <span class="company-icon">🏢</span>
          {{ corporateData?.name || 'Loading...' }}
        </h1>
        <p class="corporate-subtitle">Corporate Account Details & Member Management</p>
      </div>
     <div class="corporate-actions">
<button class="btn-action back-button" (click)="goBack()">
  <span class="icon">←</span>
  Back
</button>
</div>
    </div>
  </div>

  <!-- Corporate Details Cards -->
  <div class="corporate-cards" *ngIf="corporateData">
    <div class="detail-card">
      <div class="card-header">
        <span class="card-icon">📋</span>
        <h3>Basic Information</h3>
      </div>
      <div class="card-content">
        <div class="info-item">
          <label>Plan:</label>
          <span class="plan-badge" [class]="corporateData.plan">
            {{ corporateData.plan | titlecase }}
          </span>
        </div>
        <div class="info-item">
          <label>Company Type:</label>
          <span>{{ getCompanyTypeLabel(corporateData.companyType) }}</span>
        </div>
        <div class="info-item">
          <label>Status:</label>
          <span class="status-badge" [class]="corporateData.status">
            {{ corporateData.status | titlecase }}
          </span>
        </div>
      </div>
    </div>

    <div class="detail-card">
      <div class="card-header">
        <span class="card-icon">🏛️</span>
        <h3>Legal Information</h3>
      </div>
      <div class="card-content">
        <div class="info-item" *ngIf="corporateData.panNumber">
          <label>PAN Number:</label>
          <span class="code-text">{{ corporateData.panNumber }}</span>
        </div>
        <div class="info-item" *ngIf="corporateData.gstNumber">
          <label>GST Number:</label>
          <span class="code-text">{{ corporateData.gstNumber }}</span>
        </div>
        <div class="info-item" *ngIf="corporateData.cin">
          <label>CIN:</label>
          <span class="code-text">{{ corporateData.cin }}</span>
        </div>
      </div>
    </div>

    <div class="detail-card">
      <div class="card-header">
        <span class="card-icon">📍</span>
        <h3>Address Information</h3>
      </div>
      <div class="card-content" *ngIf="corporateData.address">
        <div class="address-block">
          <p>{{ corporateData.address.street }}</p>
          <p>{{ corporateData.address.city }}, {{ corporateData.address.state }}</p>
          <p>{{ corporateData.address.pincode }}</p>
        </div>
      </div>
    </div>

    <div class="detail-card stats-card">
      <div class="card-header">
        <span class="card-icon">👥</span>
        <h3>Members Overview</h3>
      </div>
      <div class="card-content">
        <div class="stats-grid">
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.total }}</span>
            <span class="stat-label">Total Members</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.active }}</span>
            <span class="stat-label">Active</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.inactive }}</span>
            <span class="stat-label">Inactive</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">{{ memberStats.suspended }}</span>
            <span class="stat-label">Suspended</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading corporate details...</p>
  </div>

  <!-- Error State -->
  <div class="error-container" *ngIf="error">
    <span class="error-icon">⚠️</span>
    <p>{{ error }}</p>
    <button class="retry-btn" (click)="loadCorporateData()">Retry</button>
  </div>
</div>

<!-- Members Table Section -->
<div class="members-table-container">
  <div class="table-section-header">
    <h2>
      <span class="section-icon">👥</span>
      Corporate Members
    </h2>
    <p>Manage and view all members of this corporate account</p>
  </div>
  
  <tt-shared-table name="corporatemembers"></tt-shared-table>
</div>
